export const featurePaths = {
  exhibitorList: "/exhibitors",
  createExhibitor: "/exhibitors/create",
  editExhibitor: "/exhibitors/edit",
} as const;
